/**
 * @author Pankaj.khurana@vernuso.com (Pankaj khurana)
 */
export class RuleParam {
    key: string;
    description: string;
    dataType: number;
    dataTypeDisplay: string;
    value: string;
    isCollection: boolean;
    id: number;
}
export class RuleParamDataType{
    id: number;
    name: string;
}




// WEBPACK FOOTER //
// ./src/app/admin/rules/ruleparamlist/ruleparam.model.ts